import Select from './SelectField'
import './MultipleChoiceQuestion.scss'
import { useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import CommentBox from './CommentBox'
import ComplianceIcon from './ComplianceIcon'
import { GuidanceIcon } from './GuidanceIcon'

export default function MultipleChoiceQuestion({ name, disabled, options, answer = {}, onChange: _onChange, className = '', notGraded, compliance, guidance, guidanceManager }) {
  const [comment, setComment] = useState(answer.comment || '')
  const onChange = (v) => {
    _onChange({ ...v, notGraded })
  }

  const updateComment = useDebouncedCallback((comment) => onChange({ ...answer, comment }), 300)
  const handleUpdateComment = (value) => {
    setComment(value)
    updateComment(value)
  }

  return (
    <div className={`multiple-choice-question question ${className}`}>
      <div className='base'>
        <h3 className={disabled ? 'disabled' : ''}>
          {name}
          {compliance && <ComplianceIcon />}
          {guidance ? <GuidanceIcon guidance={guidance} manager={guidanceManager} /> : ''}
        </h3>
        <span>
          <Select disabled={disabled} options={options} onChange={(v) => v.value !== answer.value && onChange(v)} value={answer.value ? answer : null} />
        </span>
      </div>
      <div className={'expandable' + (answer.allowcomment ? ' visible' : '')}>
        <CommentBox comment={comment} onChange={handleUpdateComment} placeholder='Type your reasoning here' />
      </div>
    </div>
  )
}
